import { gql } from "@apollo/client"

const FILES_JOB_STEP_FIELDS = gql`
  fragment FilesJobStepFields on FilesJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    responseUploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { FILES_JOB_STEP_FIELDS }
